import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Drawer } from '@mui/material';
import LoginContext from '../context/login_context/LoginContext';

import MenuIcon from '@mui/icons-material/Menu';
import OutputOutlinedIcon from '@mui/icons-material/OutputOutlined';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import BugReportIcon from '@mui/icons-material/BugReport';

import './main.css'

import dayjs from 'dayjs'
import { VERSION_APP } from '../router/Url';

var weekOfYear = require('dayjs/plugin/weekOfYear')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(weekOfYear)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs().tz('America/Santiago')

let RCambioCriterio = [
  "16114499-1",//MURRUTIA
  "17687529-1",//VMATURANA
  "18213587-9",//DSILVA
  "16520167-1",//ABARRERA
  "17049061-4",//PEGUTIERREZ
  "19071902-2",//CMESA
  "panolsemapai@ariztia.com",//PANOLSEMAPAI
  "26.489.095-0",//MCRUZF
  "18.693.447-4",//fareyes
  "pmantencionarica@ariztia.com",//PAÑOL MANTENCION ARICA
  "19684645-K",//ANDRES MELILLAN
  "17461699-K",//marisol ibarra
  "18061498-2",//MAURICIO FUENTES
  "16154946-0",//ivan ulloa
  "20267595-6",//joaKING
]

export const HeaderMenu = ({Pag_Sel,VisibleModal, setVisibleModal}) => {
  const navigate = useNavigate();
  const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);
  const [PageSelcected, setPageSelcected] = useState(Pag_Sel)
  const [IsHiddedn, setIsHiddedn] = useState(false);
  // console.log(LoginState);
  
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const HandleCloseSession = async () => {
    CloseLogin()
    navigate('/')
  }

  const Make_A_File_whit_all_Data = async () => {
    // await MakeMeAFile({PLANTA:LoginState.planta})
    setVisibleModal(true)
    // console.log('make method to make a one file report')
  }

  useEffect(() => {
    // const a = async () => {
    //   console.log( LoginState)
    // }
    // a()
  }, [])
  


  return (
    <>
     <div className='container-fluid header mb-2'>
        <div className='row'>

          <div className='col-12'>
            <div className='row'>
                  
              <div className="ocean_2">
                <div className="wave_2"></div>
                <div className="wave_2"></div>
                <div className="wave_2"></div>
              </div>
              <div className='col-3 my-2'>
                <img src='/favicon.png' className='puntero' height={'50px'} onClick={()=>navigate('/home')}/>
              </div>
              <div className='col-9 p-auto m-auto'>
                <div className='row'>
                  <div className='col-10'>
                    <div className='row'>
                      <div className='col-12 hidden-xs col-md-6'>
                        <b>{LoginState.planta}</b>
                      </div>
                      <div className='col-12 col-md-6 text-right'>
                        {LoginState.user}
                      </div>
                    </div>
                  </div>
                  <div className='col-2 text-right p-auto m-auto'>
                    <span className='menubtn' onClick={toggleDrawer('right', true)}><MenuIcon/></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Drawer
        anchor={'right'}
        open={state['right']}
        onClose={toggleDrawer('right', false)}
      >
      <div className='' style={{height: '100vh', width: '250px', backgroundColor: '#CD0404'}}>
        <div className='col-12' style={{height: '20vh', borderBottom: '3px solid #860000ff'}}>
          <img src='/favicon.png' style={{height: "90px", margin: '15px', filter: 'drop-shadow(0 0 5px #e5ff00ff)'}} className='px-5 ml-4' />
        </div>
        <div className='drw-menu-container' style={{height: '80vh', overflowY: 'scroll'}}>

            <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='ot'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/ot')}><PendingActionsIcon className='color-icon-menu'/><span className='spacing'></span> Orden de Trabajo</p>
            </div>

            
            <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='entrega_turno'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/home')}><FormatListNumberedIcon className='color-icon-menu'/><span className='spacing'></span> Ingreso de O.T.C</p>
            </div>

            <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='solicitudes'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/solicitudes')}><PendingActionsIcon className='color-icon-menu'/><span className='spacing'></span> Solicitud Trabajo</p>
            </div>

            <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='rev_solicitudes'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/rev_solicitudes')}><FactCheckOutlinedIcon className='color-icon-menu'/><span className='spacing'></span> Revisar Solicitudes</p>
            </div>

            {/* <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='tasks'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/tasks')}><PlaylistAddCheckIcon className='color-icon-menu'/><span className='spacing'></span> Tareas Pendientes</p>
            </div> */}

            {
              RCambioCriterio.includes(LoginState.rut)?<div className='' onClick={toggleDrawer('right', false)}>
                <p className={PageSelcected==='cambiocritico'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/cambiocritico')}><FlipCameraAndroidIcon className='color-icon-menu'/><span className='spacing'></span> Cambio de Criticidad</p>
              </div>:null
            }

            <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='pdf_big'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/pdf_big')}><MoveToInboxIcon className='color-icon-menu'/><span className='spacing'></span> PDF</p>
            </div>

            <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='log_cambio_status'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/log_cambio_status')}><FormatListNumberedIcon className='color-icon-menu'/><span className='spacing'></span> Log Cambio Solicitudes</p>
            </div>

            <div className='' onClick={toggleDrawer('right', false)}>
              <p className={PageSelcected==='hrs'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/hrs')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> Horas Fracttal</p>
            </div>

            {
              LoginState.rut==="16114499-1"?<>
                <div className='' onClick={toggleDrawer('right', false)}>
                  <p className={PageSelcected==='log_cambio_status'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/log_cambio_status')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> DEV/Log Cambio Status</p>
                </div>
                <div className='' onClick={toggleDrawer('right', false)}>
                  <p className={PageSelcected==='prueba'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/prueba')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> DEV/Prueba</p>
                </div>
                <div className='' onClick={toggleDrawer('right', false)}>
                  <p className={PageSelcected==='crudticidades'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/crudticidades')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> DEV/Crud Criticidad</p>
                </div>
                <div className='' onClick={toggleDrawer('right', false)}>
                  <p className={PageSelcected==='crudr'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/crudr')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> DEV/Crud QR</p>
                </div>
                <div className='' onClick={toggleDrawer('right', false)}>
                  <p className={PageSelcected==='entregaturno'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/entregaturno')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> DEV/Libro Turno</p>
                </div>
                <div className='' onClick={toggleDrawer('right', false)}>
                  <p className={PageSelcected==='crud_users'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/crud_users')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> DEV/Usuarios</p>
                </div>
                <div className='' onClick={toggleDrawer('right', false)}>
                  <p className={PageSelcected==='logs_login'?'menu-item selected-item':'menu-item'} onClick={()=>navigate('/logs_login')}><BugReportIcon className='color-icon-menu'/><span className='spacing'></span> DEV/Logs Login</p>
                </div>
              </>:null
            }

            <hr/>
            <p className='menu-item' onClick={()=>HandleCloseSession()}>
              <OutputOutlinedIcon className='color-icon-menu'/><span className='spacing'></span> Salir
            </p>
            <div className='menu-footer-version'>
              <small>{VERSION_APP}</small>
            </div>


        </div>
      </div>

        
      </Drawer>

    </>
  )
}
